export const SENSITIVE_DATA_CLASS = 'fs-hide';

export default {
  SENSITIVE_DATA_CLASS,
};



// WEBPACK FOOTER //
// ../react-lib/src/constants/sensitiveData.constants.js